var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-2 d-flex"}),_c('div',{staticStyle:{"width":"100%","height":"84vh"},attrs:{"id":"container"}})])
}]

export { render, staticRenderFns }